<template>
	<div class="card-number">
		<span v-for="(partial, i) of numberPartials" :key="i" class="number-partial">{{partial}}</span>
	</div>
</template>

<script>
export default {
	props: {
		value: { default: '' },
		type: {}
	},
	computed: {
		numberPartials() {
			return this.value.split(' ');
		}
	}
}
</script>

<style scoped lang="scss">
.card-number {
	display: flex;
	align-items: center;

	font-size: 1.15em;

	.number-partial:not(:last-child) {
		margin-right: 10px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/home/CardNumber.vue